import { useSelector } from 'store';
import useAuth from './useAuth';
import useErrorSnackbar from './useErrorSnackbar';

export interface FirebaseEmail {
  to: string;
  message: {
    subject: string;
    html: string;
  };
}

export default function useSendEmail() {
  const { db, user } = useAuth();
  const mailRef = db.collection('mail');
  const errorSnackbar = useErrorSnackbar();
  const { emailActive } = useSelector((state) => state.config?.mainConfig?.app || {});

  const sendEmail = async (emailObject: FirebaseEmail) => {
    if (!emailActive && user?.isStaff) {
      return errorSnackbar({ message: 'Email is not active' } as Error);
    }

    try {
      if (!emailObject.to) throw new Error('No email address provided');
      const docRef = await mailRef.add({ ...emailObject });
      console.log('Email sent with ID: ', docRef.id);
    } catch (error) {
      console.error('Error adding email: ', error);
    }
  };

  return sendEmail;
}
